import {ActionOnObject} from './ActionOnObject';

export class AddObjectAction extends ActionOnObject {
  constructor(object) {
    super(object);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/AddObjectAction.ts